import { IAttribute } from '../base/annotation';

export class ReferencedProxyNamedInfo {
    constructor(
        private _referencedResourceIdentity: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        private _parentObject: any,
        private _propertyName: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        private _proxyNamed: any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        private _parameters: any[],
        public attribute?: IAttribute
    ) {
    }

    public get referencedResourceIdentity(): string {
        return this._referencedResourceIdentity;
    }

    public set referencedResourceIdentity(val: string) {
        this._referencedResourceIdentity = val;
    }

    // Object which contains the property with proxy named
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get parentObject(): any {
        return this._parentObject;
    }

    // Name of the property/referenced object type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get propertyName(): any {
        return this._propertyName;
    }

    // Actual property/referenced object, which is a proxy named
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get proxyNamed(): any {
        return this._proxyNamed;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get parameters(): any[] {
        return this._parameters;
    }
}
